module.exports = __webpack_public_path__ + "img/snacks1.a12bc738.jpg";